import type { Store } from 'redux/store';
import { getCurrentUser } from './auth.selectors';
import { authActions, refreshToken } from './auth.slice';
import Axios from 'axios';
import { clientApi } from 'utils/api';
import { isNil } from 'utils/helper';

export const setupAuthInterceptor = (store: Store) => {
  clientApi.interceptors.request.use((requestConfig) => {
    const currentUser = getCurrentUser(store.getState());
    if (currentUser) {
      requestConfig.headers = {
        ...requestConfig.headers,
        Authorization: `Bearer ${currentUser!.accessToken}`,
      };
    }
    return requestConfig;
  });

  // Response interceptor for API calls
  clientApi.interceptors.response.use(
    (response) => {
      return response.data;
    },
    async function (error) {
      const originalRequest = error.config;
      if (isNil(error.response)) {
        return Promise.reject(error);
      } else if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        //console.log('originalRequest', originalRequest);
        var oldAccessToken = originalRequest?.headers?.Authorization?.replace(/^Bearer\s+/, '');
        //console.log('oldAccessToken', oldAccessToken, originalRequest.url);
        const refreshTokenPromise = await store.dispatch(refreshToken(oldAccessToken));
        //console.log('newAccessToken', refreshTokenPromise.accessToken, originalRequest.url);

        Axios.defaults.headers.common['Authorization'] = `Bearer ${refreshTokenPromise.accessToken}`;
        originalRequest.headers.Authorization = `Bearer ${refreshTokenPromise.accessToken}`;
        return clientApi(originalRequest);
      } else if (!error.response || error.response.status !== 401) {
        return Promise.reject(error);
      }
      return Promise.reject(store.dispatch(authActions.logout()));
    },
  );
};
